<template>
    <div class="addCar">
        <div class="addCar-type flex justify-between">
            <div class="addCar-type-item" v-for="(item, index) in carTypeList" :key="index" @click="changeType(item)">
                <p v-if="index < 2" :class="type == item.type ? 'addCar-type-item-textA' : 'addCar-type-item-text'">{{ item.name }}</p>
                <p v-if="index == 2" :class="type >= item.type ? 'addCar-type-item-textA' : 'addCar-type-item-text'">{{ item.name }} <img class="image" v-if="item.type >= 3" src="@/assets/images/pay/down.png" alt="" /></p>
            </div>
        </div>
        <div class="addCar-content">
            <!-- <div class="addCar-content-header flex align-center">
            <img src="@/assets/images/mycar/num-input-icon.png" alt="">
            <p>请绑定真实有效的车牌</p>
        </div> -->
            <!-- <van-password-input :value="value" :mask="false" :length="length" :focused="showKeyboard" @focus="showKeyboard = true" :gutter="6" /> -->
            <CarKeyboard ref="CarKeyboard" :cartype.sync="type" :carNoList.sync="carNoList" @confirmBtnFn="getResult" text="请绑定真实有效的车牌" />
            <warning-success :show.sync="showWarning" @comfirm="experience" />
        </div>

        <!-- 其他车牌弹出 -->
        <van-action-sheet v-model="showCodeType" description="请选择车牌颜色">
            <div class="content-other">
                <div :class="[activeCode == item.type ? 'content-other-itemA' : 'content-other-item']" @click="clickOtherItem(item)" v-for="(item, index) in otherCarType" :key="index">
                    <p>{{ item.name }}</p>
                </div>
                <div class="content-other-btn flex align-center justify-between">
                    <van-button @click="canclePick" plain color="#009AF3" block class="content-btn">取消</van-button>
                    <van-button @click="confirmPick" color="#009AF3" block class="content-btn">确定</van-button>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import CarKeyboard from "@/components/car-keyboard.vue";
import WarningSuccess from "@/components/base/warning-success.vue";

import { addPlateNum } from "@/api/api";
export default {
    name: "AddCar",
    components: {
        CarKeyboard,
        WarningSuccess,
    },
    data() {
        return {
            type: 1,
            oldType: "", //老的type

            carNoList: ["闽", "C"], //单个车牌号数组

            showKeyboard: false,
            showWarning: false,
            activeCode: 3, //其他类型的激活的参数
            showCodeType: false, //其他类型选择
            tmpOtherData: {
                name: "黄牌",
                type: 3,
            }, //其他车牌选中
            carTypeList: [
                {
                    name: "蓝牌",
                    type: 1,
                },
                {
                    name: "绿牌",
                    type: 2,
                },

                // {
                //     name: "其他",
                //     type: 3,
                // },
            ],

            otherCarType: [
                {
                    name: "黄牌",
                    type: 3,
                },
                {
                    name: "临牌",
                    type: 4,
                },
                {
                    name: "黑牌",
                    type: 5,
                },
                {
                    name: "白牌",
                    type: 6,
                },
                {
                    name: "黄绿",
                    type: 7,
                },
            ],
        };
    },
    computed: {},
    methods: {
        // 车牌颜色改变事件
        changeType(item) {
            //有键盘时不能修改类型
            if (this.$refs.CarKeyboard.show_keyboard) return;

            this.oldType = this.type;
            this.type = item.type;
            if (item.type == 3) {
                this.showCodeType = true;
            }
        },
        //提交
        getResult(carNo, isDefault) {
            //蓝牌 黄牌 临牌 黑牌  白牌 只能七位
            if (this.type == 1 || this.type == 3 || this.type == 4 || this.type == 5 || this.type == 6) {
                if (carNo.length < 7) {
                    this.$toast("请输入正确车牌号!");
                    return;
                }
            }

            // 绿牌 黄绿牌 八位
            else if (this.type == 2 || this.type == 7) {
                if (carNo.length < 8) {
                    this.$toast("请输入正确车牌号!");
                    return;
                }
            }

            addPlateNum({
                plateColor: this.type,
                plateNum: carNo,
                isDefault: Number(isDefault),
            }).then((res) => {
                this.showWarning = true;
            });
        },
        experience() {
            this.$router.back();
        },
        //其他车牌点击弹出
        clickOtherItem(item) {
            this.activeCode = item.type;
            this.tmpOtherData = item;
        },

        confirmPick() {
            this.showCodeType = false;
            this.carTypeList[2].name = this.tmpOtherData.name;
            this.type = this.tmpOtherData.type;
        },
        // 取消选择车牌
        canclePick() {
            this.showCodeType = false;
            this.carTypeList[2].name = "其他";
            this.type = this.oldType;
        },
    },
};
</script>

<style lang="less" scoped>
.content-other {
    .content-other-itemA {
        width: 702px;
        height: 64px;
        background: #009af333;
        border-radius: 16px;
        margin: 0 22px;
        p {
            color: #009af3;
            line-height: 64px;
            text-align: center;
        }
    }
    .content-other-item {
        width: 702px;
        height: 64px;
        // background: #009AF333;
        border-radius: 16px;
        margin: 0 22px;
        p {
            color: #666666;
            line-height: 64px;
            text-align: center;
        }
    }
    .content-other-btn {
        width: 750px;
        padding: 22px;
        .content-btn {
            width: 343px;
            height: 70px;
            border-radius: 16px;
        }
    }
}
.image {
    width: 12px;
    height: 8px;
    margin-left: 10px;
    margin-bottom: 7px;
}
.addCar {
    padding: 24px;
    background-color: #fff;
    .addCar-type {
        width: 702px;
        height: 64px;
        border: 1px solid #dbdada;
        border-radius: 16px;
        .addCar-type-item {
            height: 100%;
            flex: 1;
            .addCar-type-item-text {
                font-size: 28px;
                color: #666666;
                text-align: center;
                line-height: 64px;
                position: relative;
                &::before {
                    content: "";
                    width: 1px;
                    height: 40px;
                    position: absolute;
                    background-color: #dbdada;
                    top: 12px;
                    left: 0;
                }
            }

            &:nth-child(1) {
                .addCar-type-item-text {
                    position: relative;
                    &::before {
                        content: "";
                        width: 0;
                    }
                }
            }
            .addCar-type-item-textA {
                font-size: 28px;
                height: 100%;
                line-height: 64px;
                color: #fff;
                text-align: center;
                background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
                border-radius: 15px;
            }
        }
    }
    .addCar-content {
        width: 100%;
        margin-top: 32px;
        .addCar-content-header {
            img {
                width: 32px;
                height: 27px;
            }
            p {
                font-size: 30px;
                color: #212121;
                margin-left: 10px;
            }
        }
    }
}
</style>
<style lang="less">
.van-password-input {
    margin: 23px 0;
}
.van-password-input__item {
    border: 1px solid #eee;
    border-radius: 8px;
    height: 80px;
    width: 74px;
}
</style>
